// @ts-nocheck
import { ProductAndQuantityModel } from "@store/Framework/Types/ApiModels";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface Parameter {
    productToAddToModal?: ProductAndQuantityModel;
}

type HandlerType = Handler<Parameter>;

export const ResetProductToAdd: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/PartFinder/ResetProductToAddToModal",
    });
};

export const SetProductToAdd: HandlerType = props => {
    if (props.parameter.productToAddToModal) {
        props.dispatch({
            type: "Store/Components/PartFinder/SetProductToAddToModal",
            productToAdd: props.parameter.productToAddToModal,
        });
    }
};

export const chain = [ResetProductToAdd, SetProductToAdd];

const setProductToAddToModal = createHandlerChainRunnerOptionalParameter(chain, {}, "SetProductToAddToModal");
export default setProductToAddToModal;
